/* @flow */

import React from 'react';
import ResourceDimmer from 'shared/components/ResourceDimmer';
import { Icon } from 'semantic-ui-react';

type Props = {
  resource: BucketResource,
};

const Pdf = ({ resource }: Props) => (
  <ResourceDimmer resource={resource}>
    <div>
      <a
        href={resource.url.original}
        target="_blank"
        icon="file pdf outline"
        className="ui labeled icon button"
      >
        <Icon name="file pdf outline" />
        Télécharger
      </a>
    </div>
  </ResourceDimmer>
);

export default Pdf;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folder/components/items/Pdf.js